import { render } from "./OwnerDashboard.vue?vue&type=template&id=2f284a0d&scoped=true"
import script from "./OwnerDashboard.vue?vue&type=script&lang=js"
export * from "./OwnerDashboard.vue?vue&type=script&lang=js"

import "./OwnerDashboard.vue?vue&type=style&index=0&id=2f284a0d&scoped=true&lang=css"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f284a0d"]])

export default __exports__